import { all, takeLatest } from 'redux-saga/effects';
import { fetchPromoSearchCoupons } from 'store/promoSearchCoupons/actions';
import fetchPromoSearchCouponsWorker from './worker.fetchPromoSearchCoupons';

function* promoSearchCouponsSaga() {
  yield all([takeLatest(fetchPromoSearchCoupons, fetchPromoSearchCouponsWorker)]);
}

export default promoSearchCouponsSaga;
